/**
 * nhóm nhiệm vụ chi
 */
export default {
  Political: 1,
  Congress: 2,
  PrimeMinister: 3,
  President: 4,
  Government: 5,
  MinisterialLevel: 6,
  ProvincialPeopleCommittee: 7,
  GrassrootsLevel: 8,
};
